exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2wscP {\n  height: 50px;\n  margin-top: 20px;\n}\n", ""]);

// Exports
exports.locals = {
	"exchangeRateBox": "_2wscP"
};